//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CartMixin, AppMixin } from '~/node_modules/sitis-nuxt/lib/mixins/index';
import Options from "~/components/product/Options.vue";
import {minLength, required} from "vuelidate/lib/validators";

export default {
  data: function() {
    return {
      product: {},
      productAvailability: {},
      formFeedBack: {
        name: "",
        phone: "",
      },

      modifications: [],
      variants: [],
      selectedVariants: [{}],

      typeEyes: "same",

      isLoading: true,
      isProductEmpty: false,
      isSendFormFeedBack: false
    }
  },

  props: {

    productId: {
      type: Number,
      default: 0
    },

  },

  components: {
    Options
  },

  mixins: [
    CartMixin,
    AppMixin
  ],

  computed: {
    // Определяем выбрана ли Казань, чтобы вернуть отображение убрать из условия на 45стр. рядом с isAllSelectedOptions
    isJJ: function () {
      return this.$store.state["local-settings"].isJJ;
    },
    isShowButtonMyAcuvue: function () {
      const isInclude = Boolean(process.env.myAcuvueIncluded || false);
      const isAcuvue = Boolean(this.product?.brand?.name === "ACUVUE");

      return Boolean( isInclude && isAcuvue )
    },

    productCategory: function() {
      return this.product?.category?.name || ''
    },

    isAllSelectedOptions: function () {
      const totalCount = Object.keys(this.productAvailability || {}).length;
      const countTrue = Object.keys(this.productAvailability).filter((key) => Boolean(this.productAvailability[key])).length;
      return Boolean(totalCount === countTrue && totalCount > 0)
    },
    isAllAvaiblesModification: function () {
      let allAvaiblesModification = true;

      Object.keys(this.productAvailability).map((key) => {
        if (!this.productAvailability[key]) {
          allAvaiblesModification = false
        }
      });

      return allAvaiblesModification
    },

    isProductStocks: function () {
      const manufacturerSlug = ((this.product?.characteristics?.[0]?.characteristics || [])
        .find((t) => t.slug === "manufacturer")?.values || [])?.[0]?.slug || "";

      // if (manufacturerSlug === "cooper-vision") {
      //   return true
      // }

      let allAvaiblesModification = true;
      Object.keys(this.productAvailability).map((key) => {
        if (!this.productAvailability[key]) {
          allAvaiblesModification = false
        }
      });

      if (!allAvaiblesModification) {
        return false
      }


      return true
    },
    isProductFullDisabled: function () {
      const disabledProductIds = (this.$store.state.appState?.vars?.['ID товаров недоступных при нулевом остатке'] || "").split(",");
      if (Boolean((this.productAvailability?.[0] === false || this.productAvailability?.[1] === false) && disabledProductIds.includes(String(this.product.id)))) {
        return true
      }
      return false
    },

    initSelectedVariants: function () {
      return this.$store.state?.["fast-buy"]?.initSelectedVariants || []
    },

    bonusValue: function () {
      return this.product?.bonus_value || this.product?.bonusValue
    },

    // проверка пользователя на авторизацию Acuvue
    isUserHasMyAcuvue: function () {
      return Object.keys(this.$store?.state?.myacuvue?.profile)?.length > 0;
    },
    // Вытаскиваем из рекомендованных товар, на который у пользователя есть купон
    fittedProductsWithAcuvuePromo: function () {
      const fitted = this.$store.state?.myacuvue?.profile?.fitted_products || null;
      if (!fitted) {
        return [];
      }
      // разбираем массивоподобный объект в реальный массив для возможности парсинга
      const toArray = Array.isArray(fitted) ? fitted : Object.entries(fitted).map(([key, value]) => {
        if (value && typeof value === 'object') {
          return {
            ...value,
            id:Number(value?.id ?? key),
          };
        }
        return {
          id: Number(key),
          value,
        };
      });
      // колбэк проверки наличия значенйи в promos из стора рекомендованных линз acuvue.fitted_products
      const hasData = function (value) {
        if (!value) return false;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') return Object.keys(value).length > 0;
        return Boolean(value);
      };
      return toArray.filter((t) => hasData(t?.promos));
    },
    //проверяем, рекомендован ли этот товар
    isProductHasFitted: function () {
      const _fittedItem = this.fittedProductsWithAcuvuePromo.find((item) => item?.id === this.product?.id)
      return _fittedItem ? _fittedItem : null;
    },

    // берем лучшую цену для акций из характеристики
    isProductHasAcuvuePromotions: function () {
      const promotionsAcuvue = this.product?.characteristics?.find((item) => item.name === 'Акции MyAcuvue');
      return promotionsAcuvue && promotionsAcuvue?.characteristics?.length > 0 ? promotionsAcuvue?.characteristics : ''
    },

    productPriceFromAcuvuePromo: function () {
      // не авторизован
      if (!this.isUserHasMyAcuvue && this.isProductHasAcuvuePromotions) {
        return `${ this.$numberFormat(this.isProductHasAcuvuePromotions?.[0]?.values?.[0]?.slug)} ₽`;
      }
      //авторизован и есть рекомендации от врача
      if (this.isUserHasMyAcuvue && this.isProductHasFitted) {
        return this.isProductHasFitted ? `${this.$numberFormat(this.isProductHasFitted?.price_from)} ₽` : null;
      }
      return null;
    },

    productPromotionDescriptionFromAcuvuePromo: function () {
      // не авторизован
      if (!this.isUserHasMyAcuvue && this.isProductHasAcuvuePromotions) {
        return this.isProductHasAcuvuePromotions ? this.isProductHasAcuvuePromotions?.[1]?.values?.[0]?.value : '';
      }
      //авторизован и есть рекомендации от врача
      if (this.isUserHasMyAcuvue && this.isProductHasFitted) {
        return this.isProductHasFitted && Object.keys(this.isProductHasFitted?.promos)?.length > 0 ? this.isProductHasFitted?.promos?.description : '';
      }
      return null;
    },
  },

  validations: function() {
    const formFeedBack = {
      name: { required },
      phone: { required, minLength: minLength(18) },
    };

    return {
      formFeedBack
    };
  },

  mounted: async function () {
    this.$modal.show("fast-buy-product");
    await this.getProduct();
  },

  methods: {

    getDeliveryDays: function () {
      const isJohnsonJohnson = Boolean(((this.product?.characteristics?.[0]?.characteristics || [])
        .find((t) => t.slug === "manufacturer")?.values || [])
        .find((t) => t.slug === "johnson-johnson"));


      return isJohnsonJohnson ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки']
    },

    // Загрузка изменяемого продукта с его модификациями
    getProduct: async function() {
      const { data: product } = await this.$api.agent.transport.get(`products/${ this.productId }`);

      const modifications = product?.modifications || [];
      const variants = product?.variants;

      this.product = product;
      this.modifications = modifications.map((modifcation) => {
        return {...modifcation, ids: modifcation.variants.map((variant) => +variant.id)}
      });
      this.variants = variants;

      if (this.initSelectedVariants.length > 0) {
        let newSelectedVariants = [];
        this.initSelectedVariants.map((item) => {
          let variant = {};
          Object.keys(item).map((key) => {
            variant[key] = item[key]
          });
          newSelectedVariants.push(variant)
        })

        this.selectedVariants = newSelectedVariants;
      }

      this.isLoading = false;
    },

    // Добавление товара в корзину
    addToCart: async function () {
      let isAllSelected = true;

      const productVariants = [...(this.product?.variants || [])]
        .filter((t) => !Boolean(['bundles'].includes(t?.name)))

      const countVariants = productVariants?.length || 0;
      this.selectedVariants.map((selected) => {
        if (Object.keys(selected).length < countVariants) {
          isAllSelected = false;
        }
      });

      if (!isAllSelected) {
        this.$customNotification.error("Необходимо выбрать опции товара");

        return
      }

      const isNotProductStocks = await this.$api.agent.transport.get(`/delivery-term/check-available?product_id=${this.product?.id}`).then((res) => {
        return res?.data
      }).catch(() => {
        return false
      })
      if (isNotProductStocks) {
        this.$store.commit("dialog-not-avaible-notification/setOpen", {
          product: this.product,
          selectedVariants: this.selectedVariants
        });
        this.close();

        return
      }

      this.isLoading = true;

      await Promise.all(this.selectedVariants.map(async (selected) => {
        const _modifications = Object.keys(selected)
          .map((key) => Boolean(selected[key]?.id !== -1) ? `v[${key}]=${selected[key]?.id}` : null)
          .filter((t) => !!t)
          .join('&');
        const search = `products/${ this.product?.id }/modifications?${ _modifications }`;
        const { data: modifications } = await this.$api.agent.transport.get(search);

        const response = await this.$api.agent.transport.post(`cart`, {
          "product_id": this.product?.id || 0,
          "modification_id": modifications?.[0]?.id,
          "quantity": 1
        }).then((res) => {
          return res.data
        }).catch((err) => {
          return {error: err.response}
        });
        if (response?.error) {
          const errorMessage = response?.error?.data?.[0]?.message || response?.error?.data?.message || "Ошибка при добавлении товара в корзину";
          this.$toast.error(errorMessage)
        } else {
          this.$yandexCommerce("add", [{
            ...this.product,
            quantity: 1
          }]);
          this.$vkGoalWr("QuickCart", {}, process.env.vkPixelCode);
        }
      }));

      await this.getCart();
      await this.$store.dispatch("mindbox/productCartChange");

      this.isLoading = false;

      this.close();

      this.$emit("successSubmit");
    },

    // Изменение типа глаз
    changeTypeEyes(typeEyes) {
      if (typeEyes === this.typeEyes) {
        return null;
      }

      this.typeEyes = typeEyes;

      if (typeEyes === "various") {
        this.selectedVariants.push({});
      }
      if (typeEyes === "same") {
        this.selectedVariants = [...this.selectedVariants].splice(0, 1);
      }

      (async () => {
        await this.updateProductAvailability();
      })();
    },

    // Изменение выбрнных опиций
    changeSelected: function(selected, idx) {
      let newSelectedVariants = [...this.selectedVariants];
      newSelectedVariants[idx] = selected;

      this.selectedVariants = newSelectedVariants;

      this.updateProductAvailability();
    },

    close: function() {
      this.$store.commit('fast-buy/setProductId', -1);
      this.$store.commit('fast-buy/setProductInitSelectedVariants', []);
      this.$emit('close');
    },

    // Изменение модификаций
    updateProductAvailability: async function () {
      const productAvailability = {};
      const selected = this.selectedVariants || [];

      // Проход по наборам выбранных параметров
      await Promise.all(selected.map(async (select, index) => {
        let isAllSelected = true;
        const countVariants = this.product?.variants?.length || 0;
        if (Object.keys(select).length < countVariants) {
          isAllSelected = false;
        }

        if (this.isProductEmpty) {
          productAvailability[index] = false;

          return null
        }
        if (!isAllSelected) {
          return null
        }

        const _modifications = Object.keys(select)
          .map((key) => Boolean(select[key]?.id !== -1) ? `v[${key}]=${select[key]?.id}` : null)
          .filter((t) => !!t)
          .join('&')
        const search = `products/${ this.productId }/modifications?${ _modifications }&expand=stores`;
        const { data: modifications } = await this.$api.agent.transport.get(search);

        const currentCityId = this.$store.state?.appState?.config?.city?.data?.id || this.$store.state?.appState?.config?.city?.model?.id;
        const filterModifications = (modifications || []).filter((modification) => {
          const stores = (modification?.stores || []).filter((store) => Boolean(String(store?.city_id) === String(currentCityId)));
          return Boolean(stores.length > 0)
        });

        productAvailability[index] = Boolean((filterModifications?.[0]?.quantity || 0) > 0);
        // productAvailability[index] = Boolean((modifications?.[0]?.quantity || 0) > 0);
      }));

      this.productAvailability = productAvailability;
    },
    onEmptyModification: function (index) {
      const productAvailability = {...this.productAvailability};

      productAvailability[index] = false;

      this.productAvailability = productAvailability;
      this.isProductEmpty = true;
    },

    getLabelProductAcuvueFitted0: function () {
      if (!this.isShowButtonMyAcuvue) {
        return ''
      }

      const myAcuvue = this.$store.state?.myacuvue?.profile || {};

      if (Object.keys(myAcuvue).length <= 0) {
        return "Получить скидку на эти линзы в MyACUVUE®"
      }
    },
    getLabelProductAcuvueFitted1: function () {
      if (!this.isShowButtonMyAcuvue) {
        return ''
      }

      const myAcuvue = this.$store.state?.myacuvue?.profile || {};
      const fittedProducts = myAcuvue?.fitted_products || {};
      const isProfileVouchers = myAcuvue?.discount_vouchers || [];

      if (isProfileVouchers.length > 0 && fittedProducts[this.productId]) {
        return "Вам доступна скидка 300/500 рублей"
      }
    },
    getLabelProductAcuvueFitted2: function () {
      if (!this.isShowButtonMyAcuvue) {
        return ''
      }

      const myAcuvue = this.$store.state?.myacuvue?.profile || {};
      const fittedProducts = myAcuvue?.fitted_products || {};

      if (fittedProducts[this.productId] && fittedProducts[this.productId]?.bonuses > 0){
        return `За покупку вам будут начислено ${ fittedProducts?.[this.productId]?.bonuses } баллов MyAcuvue`
      }
    },


    // Оформление пред заказа
    sendFormFeedBack: async function () {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return null;
      }

      this.isSendFormFeedBack = true;

      const productVariants = this.product.variants || []
      let messages = [];
      this.selectedVariants.map((variant) => {
        let message = [];
        Object.keys(variant).map((key) => {
          const labelVariant = variant[key]?.label || ""
          const variantName = productVariants.find((t) => +key === +t.group_id)?.name || "";
          message.push(`${variantName}: ${ labelVariant }`)
        })
        messages.push(message.join(', '))
      })

      let modificationIds = [];
      await Promise.all(this.selectedVariants.map(async (selected) => {
        const _modifications = Object.keys(selected)
          .map((key) => Boolean(selected[key]?.id !== -1) ? `v[${key}]=${selected[key]?.id}` : null)
          .filter((t) => !!t)
          .join('&');
        const search = `products/${this.product?.id}/modifications?${ _modifications }`;
        const {data: modifications} = await this.$api.agent.transport.get(search);

        modificationIds.push(modifications?.[0]?.id)
      }));

      let source = [];
      modificationIds.map((modificationId) => {
        source.push({
          product_id: this.product.id,
          modifiacation_id: modificationId
        })
      })

      const response = await this.$api.agent.transport.post('/form/send', {
        ...this.formFeedBack,
        phone: (this.formFeedBack.phone || "").replace(/[^\d]/g, ''),
        type: "Заявка на линзы",
        message: `Здравствуйте, меня интересуют контактные линзы ${this.product.name}, с параметрами: ${messages.join("; ")}`,
        source: JSON.stringify(source)
      }).then((res) => {
        return res.data
      }).catch((err) => {
        return { error: err.response }
      })
      if (response.error) {
        this.isSendFormFeedBack = false;

        this.$toast.error(response.error?.data?.[0]?.message || response.error?.data?.message || "Ошибка сервера")

        return
      }

      this.isSendFormFeedBack = false;

      this.$toast.success("Заявка успешно отправлена")

      this.close();

    },
  }
};
